/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'dish': {
    width: 26.313,
    height: 21.5,
    viewBox: '0 0 26.313 21.5',
    data: '<path pid="0" d="M13.156 5.038c-6.582 0-11.937 5-11.937 11.135h1.925c0-5.078 4.491-9.21 10.012-9.21s10.012 4.132 10.012 9.21h1.924c0-6.14-5.353-11.135-11.936-11.135z" _fill="#959595"/><path pid="1" d="M25.351 15.403H.963a.963.963 0 100 1.925h24.388a.963.963 0 100-1.925zM25.351 19.575H.963a.963.963 0 000 1.925h24.388a.963.963 0 100-1.925zM13.317 0a3.369 3.369 0 103.37 3.371A3.373 3.373 0 0013.317 0zm0 4.813a1.444 1.444 0 111.444-1.444 1.446 1.446 0 01-1.444 1.444z" _fill="#959595"/>'
  }
})
